import { graphql } from '../../../graphql/generated';

export const UPDATE_INSURANCE_MUTATION = graphql(`
  mutation UpdateInsurance($id: ID!, $input: InsuranceInput!) {
    updateInsurance(id: $id, input: $input) {
      id
    }
  }
`);
